module.exports = {
  env: 'production',
  apiUrl: '',
  healthUrl: '/healthsecured'
}
